var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-swipe',{staticClass:"banner",attrs:{"autoplay":3000,"indicator-color":"white"}},_vm._l((_vm.banners),function(item){return _c('van-swipe-item',{key:item.id},[_c('a',{staticClass:"item",style:('background:url('+item.code+') no-repeat;background-size: 100%;'),attrs:{"href":item.link}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }